import { fetchAuthSession } from 'aws-amplify/auth';
import outputs from '../../amplify_outputs.json';

const API_BASE: string =
  (import.meta.env.VITE_API_ENDPOINT as string) ||
  (outputs as any).custom?.API_ENDPOINT ||
  '';

async function getToken(): Promise<string> {
  const session = await fetchAuthSession();
  return session.tokens?.idToken?.toString() ?? '';
}

export async function apiPost<T>(path: string, body: object): Promise<T> {
  const token = await getToken();
  const res   = await fetch(`${API_BASE}${path}`, {
    method:  'POST',
    headers: {
      'Content-Type':  'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text();
    let message = text;
    try { const j = JSON.parse(text); message = j.error ?? j.message ?? text; } catch { /* use raw text */ }
    throw new Error(message);
  }
  return res.json();
}

export async function apiGet<T>(path: string): Promise<T> {
  const token = await getToken();
  const res   = await fetch(`${API_BASE}${path}`, {
    headers: { 'Authorization': `Bearer ${token}` },
  });
  if (!res.ok) {
    const text = await res.text();
    let message = text;
    try { const j = JSON.parse(text); message = j.error ?? j.message ?? text; } catch { /* use raw text */ }
    throw new Error(message);
  }
  return res.json();
}
